// extracted by mini-css-extract-plugin
export default {"reset":"m4NTwe","visuallyHidden":"wlZk6Z"};